// fr strings for messages/library.ts. Same keys and {variables} as en there.
// {category} is the French name below, used after "voix IA" the way people
// search ("voix IA anime", "voix IA jeux vidéo") or after "catégorie", so no
// "de"/"d'" elision is needed.
import type { Dict } from "../index";

const library: Dict = {
  "library.of": "{name}",
  "library.ofLanguage": "en {name}",

  "library.seo.title": "Bibliothèque de voix IA{filter} | Jammable",
  "library.seo.titleFiltered": "Bibliothèque de voix IA - {filter} | Jammable",
  "library.seo.description":
    "Découvre plus de 93 000 voix IA. Crée des covers IA avec des voix d'anime, de jeux vidéo, de dessins animés, de K-pop et plus encore. De nouvelles voix chaque jour.",
  "library.seo.ogDescription":
    "Découvre plus de 93 000 voix IA. Crée des covers IA avec des voix d'anime, de jeux vidéo, de dessins animés, de K-pop et plus encore.",
  "library.seo.listDescription":
    "Voix IA Jammable. Créateur de covers IA. Synthèse vocale. Une technologie IA de pointe. Plus de 50 000 voix pour tes covers IA.",
  "library.seo.listDescriptionFiltered":
    "Voix IA {filter}. Créateur de covers IA {filter}. Synthèse vocale. Une technologie IA de pointe. Plus de 50 000 voix pour tes covers IA.",
  "library.crumb.home": "Accueil",
  "library.crumb.library": "Bibliothèque de voix IA",
  "library.crumb.filter": "Voix {category}",

  "library.title": "Bibliothèque de voix",
  "library.subtitle":
    "Plus de 93 000 voix. Touches-en une pour l'écouter, ou fais une cover tout de suite.",
  "library.train": "Entraîne ta propre voix",
  "library.search": "Rechercher des voix",
  "library.searchIn": "Rechercher dans la catégorie {categoryLower}",
  "library.categoriesNav": "Catégories de voix",
  "library.all": "Toutes",
  "library.moreCategories": "Plus de catégories",
  "library.fewerCategories": "Moins de catégories",
  "library.collections": "Collections",
  "library.collections.prev": "Collections précédentes",
  "library.collections.next": "Plus de collections",
  "library.collection.voices": "{n} voix",
  "library.voicesIn": "Voix {category}",
  "library.allVoices": "Toutes les voix",
  "library.empty.title": "Aucune voix trouvée",
  "library.empty.body": "Essaie un autre nom, ou entraîne la voix toi-même.",
  "library.loadMore": "Charger plus de voix",

  "library.sort.aria": "Trier les voix",
  "library.sort.hot": "Tendances du jour",
  "library.sort.hot.short": "Tendances",
  "library.sort.top": "Les plus utilisées",
  "library.sort.top.short": "Plus utilisées",
  "library.sort.liked": "Les plus aimées",
  "library.sort.liked.short": "Plus aimées",
  "library.sort.new": "Les plus récentes",
  "library.sort.new.short": "Récentes",

  "library.hub.title":
    "Voix IA {category} : crée des covers IA avec les voix {category} | Jammable",
  "library.hub.titlePage": "Voix IA {category}, page {page} | Jammable",
  "library.hub.description":
    "Découvre plus de {count} voix IA {category} sur Jammable. Choisis une voix pour créer une cover IA ou utilise le modificateur de voix IA.",
  "library.hub.descriptionPage":
    "Page {page} sur {lastPage} des voix IA {category} sur Jammable, classées par utilisations. Choisis une voix pour créer une cover IA ou utilise le modificateur de voix IA.",
  "library.hub.name": "Voix IA {category}",
  "library.hub.crumbVoices": "Voix IA",
  "library.hub.voices": "Voix",
  "library.hub.page": "Page {page}",
  "library.hub.h1": "Voix IA {category}",
  "library.hub.intro":
    "Découvre plus de {count} voix IA {category}. Choisis-en une pour créer une cover IA, ou utilise-la comme modificateur de voix.",
  "library.hub.popular": "Voix populaires : {categoryLower}",
  "library.hub.mostUsedPage":
    "Voix les plus utilisées dans la catégorie {categoryLower}, page {page} sur {lastPage}",
  "library.hub.noMatch":
    "Aucune voix de la catégorie {categoryLower} ne correspond à ta recherche.",
  "library.hub.openLibrary": "Ouvrir dans la bibliothèque de voix",
  "library.hub.moreCategories": "Découvre d'autres catégories",
  "library.hub.faq": "Questions fréquentes",
  "library.hub.keepExploring": "Continue d'explorer",
  "library.hub.moreWays": "Plus de façons de créer avec Jammable.",
  "library.hub.link.aiCover": "Générateur de covers IA",
  "library.hub.link.voiceChanger": "Modificateur de voix IA",
  "library.hub.link.allVoices": "Voir toutes les voix IA",
  "library.hub.pages": "Pages",
  "library.hub.first": "Première",
  "library.hub.prev": "Précédente",
  "library.hub.next": "Suivante",
  "library.hub.last": "Dernière",
  "library.hub.faq1.q": "Que sont les voix IA {category} ?",
  "library.hub.faq1.a":
    "Les voix IA {category} sont des modèles de voix de la catégorie {categoryLower} que tu peux utiliser pour créer des covers IA ou modifier ta propre voix. Jammable en compte plus de {count}, et de nouvelles voix arrivent chaque jour.",
  "library.hub.faq2.q": "Comment utiliser une voix IA {category} ?",
  "library.hub.faq2.a":
    "Ouvre une voix de la catégorie {category}, ajoute un audio que tu as le droit d'utiliser (ou enregistre le tien) et lance la génération. Jammable convertit le chant dans cette voix et te livre la cover finie en quelques secondes.",
  "library.hub.faq3.q": "Combien y a-t-il de voix {category} ?",
  "library.hub.faq3.a":
    "Jammable compte actuellement plus de {count} voix IA {category}, et la bibliothèque s'agrandit chaque jour grâce aux voix que la communauté importe et entraîne.",

  "library.cat.public-figure": "personnalités",
  "library.cat.music": "musique",
  "library.cat.cartoon": "dessins animés",
  "library.cat.gaming": "jeux vidéo",
  "library.cat.fictional": "personnages fictifs",
  "library.cat.anime": "anime",
  "library.cat.influencer": "influenceurs",
  "library.cat.singer": "chanteurs",
  "library.cat.comedy": "humour",
  "library.cat.pop": "pop",
  "library.cat.youtuber": "youtubeurs",
  "library.cat.tv-show": "séries TV",
  "library.cat.rap": "rap",
  "library.cat.fictional-character": "personnages fictifs",
  "library.cat.movie": "films",
  "library.cat.movies": "films",
  "library.cat.funny": "humour",
  "library.cat.kpop": "K-pop",
  "library.cat.k-pop": "K-pop",
  "library.cat.parody": "parodies",
  "library.cat.animation": "animation",
  "library.cat.animated": "animation",
  "library.cat.rock": "rock",
  "library.cat.vtuber": "VTubers",
  "library.cat.fantasy": "fantasy",
  "library.cat.game": "jeux",
  "library.cat.entertainment": "divertissement",
  "library.cat.rapper": "rappeurs",
  "library.cat.horror": "horreur",
  "library.cat.actor": "acteurs",
  "library.cat.actors": "acteurs",
  "library.cat.actress": "actrices",
  "library.cat.meme": "mèmes",
  "library.cat.action": "action",
  "library.cat.educational": "éducatif",
  "library.cat.hip-hop-rap": "hip-hop/rap",
  "library.cat.hip-hop": "hip-hop",
  "library.cat.adventure": "aventure",
  "library.cat.tv": "TV",
  "library.cat.female": "féminines",
  "library.cat.male": "masculines",
  "library.cat.superhero": "super-héros",
  "library.cat.drama": "drame",
  "library.cat.sci-fi": "science-fiction",
  "library.cat.science-fiction": "science-fiction",
  "library.cat.alternative": "alternatif",
  "library.cat.metal": "metal",
  "library.cat.technology": "technologie",
  "library.cat.indie": "indie",
  "library.cat.celebrity": "célébrités",
  "library.cat.fiction": "fiction",
  "library.cat.american": "américaines",
  "library.cat.british": "britanniques",
  "library.cat.australian": "australiennes",
  "library.cat.latino": "latinos",
  "library.cat.mexico": "Mexique",
  "library.cat.villain": "méchants",
  "library.cat.politics": "politique",
  "library.cat.president": "présidents",
  "library.cat.animal": "animaux",
  "library.cat.animals": "animaux",
  "library.cat.dog": "chiens",
  "library.cat.cat": "chats",
  "library.cat.sports": "sport",
  "library.cat.wrestling": "catch",
  "library.cat.streamer": "streamers",
  "library.cat.country": "country",
  "library.cat.robot": "robots",
  "library.cat.sound-effects": "effets sonores",
  "library.cat.historical": "personnages historiques",
  "library.cat.folk": "folk",
  "library.cat.r-b": "R&B",
  "library.cat.rnb": "R&B",
  "library.cat.jazz": "jazz",
  "library.cat.reggaeton": "reggaeton",
  "library.cat.electronic": "musique électronique",
  "library.cat.pop-music": "musique pop",
  "library.cat.comic": "BD et comics",
  "library.cat.demon": "démons",
  "library.cat.news": "actualités",
  "library.cat.artist": "artistes",
  "library.cat.artistas": "artistes",
  "library.cat.cantantes": "chanteurs",
  "library.cat.cantante": "chanteurs",
  "library.cat.personajes": "personnages",
  "library.cat.character": "personnages",
  "library.cat.singing": "chant",
  "library.cat.mystery": "mystère",
  "library.cat.christmas": "Noël",
  "library.cat.sitcom": "sitcoms",
  "library.cat.pirate": "pirates",
  "library.cat.toy": "jouets",
  "library.cat.classic": "classiques",
  "library.cat.art": "art",
  "library.cat.poetry": "poésie",
  "library.cat.food": "cuisine",
  "library.cat.fashion": "mode",
  "library.cat.family": "famille",
  "library.cat.podcast": "podcasts",
  "library.cat.radio": "radio",
  "library.cat.ai": "IA",
  "library.cat.artificial-intelligence": "intelligence artificielle",
  "library.cat.song": "chansons",
  "library.cat.ringtone": "sonneries",
  "library.cat.web-series": "web-séries",
  "library.cat.idol": "idols",
  "library.cat.dub": "doublage",
  "library.cat.80s": "années 80",
  "library.cat.indie-games": "jeux indé",
  "library.cat.game-show": "jeux télévisés",
  "library.lang.japanese": "japonais",
  "library.lang.japenese": "japonais",
  "library.lang.korean": "coréen",
  "library.lang.spanish": "espagnol",
  "library.lang.english": "anglais",
  "library.lang.french": "français",
  "library.lang.italian": "italien",
  "library.lang.german": "allemand",
  "library.lang.deutsch": "allemand",
  "library.lang.russian": "russe",
  "library.lang.hebrew": "hébreu",
  "library.lang.chinese": "chinois",
  "library.lang.arabic": "arabe",
  "library.lang.swedish": "suédois",
  "library.lang.polish": "polonais",
  "library.lang.turkish": "turc",
  "library.lang.finnish": "finnois",
  "library.lang.greek": "grec",
  "library.lang.indonesian": "indonésien",
  "library.lang.thai": "thaï",
  "library.lang.hungarian": "hongrois",
  "library.lang.filipino": "philippin",
  "library.lang.malaysian": "malais",
  "library.lang.portuguese": "portugais",
  "library.lang.brasileiro": "portugais du Brésil",
  "library.lang.pt-br": "portugais du Brésil",
  "library.lang.romanian": "roumain",
  "library.lang.hindi": "hindi",
  "library.lang.dutch": "néerlandais",
  "library.lang.czech": "tchèque",
  "library.lang.vietnamese": "vietnamien",
};

export default library;
